import request, { FAIL, SUCCESS } from "../util/Request";

type GetBoardListArray = [number, number, string, string, string?, string?, string?];
type UpdateList = [number, string, string?, string?, string?];

interface DownloadResponse {
  status: string;
  [key: string]: any;
}

type GetAssignVocResponseType = {
  status: string;
  data?: any;
};

const AdminBoardService = {
  getVocBoardList: async (...props: GetBoardListArray) => {
    // console.log(props);
    const page = props[0];
    const size = props[1];
    const adminPassword = props[2];
    const progress = props[3];
    const nameKeyword = props[4];
    const titleKeyword = props[5];
    const empNmKeyword = props[6];

    try {
      const response = await request.get(
        `/vocAdmin?page=${page}&size=${size}&pw=${adminPassword}&accept=${progress}&nameKeyword=${nameKeyword}&titleKeyword=${titleKeyword}&empNmKeyword=${empNmKeyword}`
      );
      // console.log("response", response);
      if (request.isSuccess(response)) {
        return {
          ...response,
          status: SUCCESS,
        };
      }
      return { status: FAIL };
    } catch (error) {
      return {
        status: FAIL,
      };
    }
  },

  getAssignVoc: async (): Promise<GetAssignVocResponseType> => {
    try {
      const response = await request.get(`/empList`);

      if (request.isSuccess(response)) {
        return {
          ...response,
          status: SUCCESS,
        };
      }
      return { status: FAIL };
    } catch (error) {
      return {
        status: FAIL,
      };
    }
  },

  getSearchRangeDate: async (formatDate: String[]) => {
    // console.log("formatDate api", formatDate);
    try {
      const response = await request.get(`/dateCheck?searchStartDate=${formatDate[0]}&searchEndDate=${formatDate[1]}`);

      if (request.isSuccess(response)) {
        return {
          ...response,
          status: SUCCESS,
        };
      }
      return { status: FAIL };
    } catch (error) {
      return {
        status: FAIL,
      };
    }
  },

  updateAdminVoc: async (...props: UpdateList) => {
    // console.log(props);
    const number = props[0];
    const accept = props[1];
    const selectAssignPerson = props[2];
    const selectAssignPersonName = props[3];
    try {
      const response = await request.post(`/vocAdmin`, {
        no: number,
        accept: accept,
        empId: selectAssignPerson,
        empNm: selectAssignPersonName,
      });
      // console.log(response);
      if (request.isSuccess(response)) {
        return {
          ...response,
          status: SUCCESS,
        };
      }
      return { status: FAIL };
    } catch (error) {
      return {
        status: FAIL,
      };
    }
  },
  fileDownload: async (no: number | undefined): Promise<DownloadResponse> => {
    try {
      const headers: any = { "Content-Type": "application/json" };
      const response = await request
        .get(`/download?no=${no}`, {
          responseType: "blob",
          headers,
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "application/zip" });
          const fileObjectUrl = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = fileObjectUrl;
          a.download = `다운로드`;
          document.body.appendChild(a);
          a.click();
          setTimeout((_: any) => {
            window.URL.revokeObjectURL(fileObjectUrl);
          }, 60000);
          a.remove();
          return response;
        });

      if (request.isSuccess(response)) {
        return {
          ...response,
          status: SUCCESS,
        };
      }
      return { status: FAIL };
    } catch (error) {
      return {
        status: FAIL,
      };
    }
  },
};

export default AdminBoardService;
